module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [(_vm.loggedIn) ? _c('li', {
    staticClass: "dropdown user-acc"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! " + _vm._s(_vm.user))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user-basket"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.items), function(item) {
    return _c('li', [(!item.checked_out) ? _c('div', [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.product_price) + " NGN")]), _vm._v(" "), _c('span', {
      staticClass: "qty"
    }, [_vm._v("QTY: " + _vm._s(item.quantity))]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.removeFromCart(item)
        }
      }
    }, [_vm._v("Remove")]), _vm._v("kk" + _vm._s(item.checked_out) + "\r\n                            ")])]) : _vm._e()])
  }), _vm._v(" "), _c('li', [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("SUBTOTAL: " + _vm._s(_vm.total) + " NGN")])]), _vm._v(" "), _c('li', {
    staticClass: "margin-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 "
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v("CHECK OUT")])])])])], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("./static/assets/images/logo.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "contact"
    }
  }, [_vm._v("Tour Markets")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("MY CART")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("ACCOUNT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("LOG OUT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "cart",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "icon-basket-loaded"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('div', {
    staticClass: "cart-img"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive",
    attrs: {
      "src": "static/assets/images/cart-img-1.jpg",
      "alt": "..."
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "shopping-cart.html"
    }
  }, [_vm._v("VIEW CART")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20e56ada"}!./src/pages/MainHeader/template.html
// module id = 276
// module chunks = 0